<div class="container">
    <h1>INSERCIÓN DE HELICOILS</h1>

   
    <div style="text-align: center;"> <img src="assets/imagenes/helicoils1.jpeg" width="480" height="360"><img
            src="assets/imagenes/helicoil2.jpg" width="480" height="360">
    </div>
</div>